import { useState, useEffect, useRef } from 'react';
import throttle from 'lodash/throttle';
const SCROLL_VALUE_FOR_STICKY = 100;
export const useSimpleIsSticky = (offsetTop = 0) => {
    const [isSticky, setIsSticky] = useState(false);
    const [startScrollPosition, setStartScrollPosition] = useState(null);
    const [prevScrollPosition, setPrevScrollPosition] = useState(0);
    const elementRef = useRef(null);
    const handleScroll = throttle(() => {
        if (elementRef.current) {
            const currentScrollPosition = window.scrollY;
            const isScrolledUp = currentScrollPosition < prevScrollPosition;
            if (startScrollPosition === null && currentScrollPosition > 0) {
                setStartScrollPosition(currentScrollPosition);
            }
            if (!isScrolledUp && startScrollPosition !== null) {
                setStartScrollPosition(null);
            }
            const scrolledUpForVisibility = isScrolledUp &&
                startScrollPosition !== null &&
                startScrollPosition - currentScrollPosition > SCROLL_VALUE_FOR_STICKY;
            setPrevScrollPosition(currentScrollPosition);
            const elementTop = elementRef.current.getBoundingClientRect().top;
            if (elementTop <= offsetTop && scrolledUpForVisibility) {
                setIsSticky(true);
            }
            else {
                setIsSticky(false);
            }
        }
    }, 100);
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll]);
    return {
        ref: elementRef,
        isSticky,
    };
};
